export default __webpack_public_path__ + "static/media/message-center.4a2c0feb.svg";